<template>
    <div class="contaier" @touchmove.prevent @click="guideClick">
        <!-- 气泡领取浮层 -->
        <template v-if="guideType < 10">
            <div
                class="guide"
                :style="{
                    marginLeft: guideMarginLeft() + 'px',
                    marginTop: guideMarginTop() + 'px',
                }"
            >
                <div class="guide-bg qipao-bg">
                    {{ bubbleData.afterRewardScore }}
                </div>
                <div class="guide-tit">{{ bubbleData.title }}</div>
                <div class="guide-df"></div>
            </div>
        </template>
        <!-- 做任务浮层 -->
        <template v-else-if="guideType === 10">
            <div class="butn-guide" v-if="taskListData">
                <div class="task-card">
                    <div class="card-tit">{{ taskListData[0].title }}</div>
                    <div class="card-desc">{{ taskListData[0].desc }} ></div>
                </div>
                <div class="butn-guide-df"></div>
            </div>
        </template>
        <!-- 浮动权益蒙层 -->
        <template v-else>
            <div :class="['quan-bg', 'postion' + (guideType - 20)]">
                <div class="quan-title">{{ bubbleData.title }}</div>
                <div class="quan-value">{{ bubbleData.desc }}</div>
                <div class="quan-desc">仅限今日</div>
                <div :class="butnStyle(bubbleData)">{{ butnTitle(bubbleData) }}</div>
                <div class="quan-df"></div>
            </div>
        </template>
    </div>
</template>
<script>
export default {
    // guideType: < 10 为气泡蒙层引导,10:有营销任务栏的蒙层引导, 11:无营销任务栏蒙层引导, >20为浮动权益蒙层引导
    props: ['guideType', 'bubbleData', 'scoreInfoData', 'taskListData'],
    data() {
        return {
            screenHeight: screen.height
        };
    },
    watch: {
        guideType: {
            deep: true,
            immediate: true,
            handler: function(newV) {
                if (newV >= 0 && newV < 12) {
                    this.POINT('h5_element_imp', {
                        page: 'super-成长权益页',
                        tgt_event_id: 'h5_ACT_privilege_0djdjydmc',
                        tgt_name: 'h5-ACT-成长权益-0等级点击引导蒙层',
                        param: this.scoreInfoData.totalScore,
                        param1: this.scoreInfoData.allScore,
                        param2: newV < 10 ? '气泡' : '任务按钮',
                        param3: this.bubbleData.score,
                        param4: this.bubbleData.title,
                        param5: '否'
                    });
                } else if (newV > 19) {
                    this.POINT('h5_element_imp', {
                        page: 'super-成长权益页',
                        tgt_event_id: 'h5_ACT_privilege_fdqydjydmc',
                        tgt_name: 'h5-ACT-成长权益-浮动权益点击引导蒙层',
                        param: this.scoreInfoData.totalScore,
                        param1: this.scoreInfoData.allScore,
                        param2: this.bubbleData.desc,
                        param3: this.butnTitle(this.bubbleData),
                        param4:
                            this.bubbleData.benefitKey === 'fdqy'
                                ? this.bubbleData.couponBatchNo
                                : '',
                        param5: '否'
                    });
                }
            }
        }
    },
    methods: {
        guideMarginLeft() {
            let marginLeft = 0;
            switch (this.guideType) {
                case 0: {
                    if (this.screenHeight >= 896) {
                        marginLeft = -48;
                    } else if (this.screenHeight >= 812) {
                        marginLeft = -28;
                    } else if (this.screenHeight >= 667) {
                        marginLeft = -32;
                    } else {
                        marginLeft = -20;
                    }
                    break;
                }
                case 1: {
                    if (this.screenHeight >= 896) {
                        marginLeft = 110;
                    } else if (this.screenHeight >= 812) {
                        marginLeft = 130;
                    } else if (this.screenHeight >= 667) {
                        marginLeft = 130;
                    } else {
                        marginLeft = 150;
                    }
                    break;
                }
                case 2: {
                    if (this.screenHeight >= 896) {
                        marginLeft = 64;
                    } else if (this.screenHeight >= 812) {
                        marginLeft = 70;
                    } else if (this.screenHeight >= 667) {
                        marginLeft = 42;
                    } else {
                        marginLeft = 32;
                    }
                    break;
                }
                case 3: {
                    if (this.screenHeight >= 812) {
                        if (this.screenHeight >= 896) {
                            marginLeft = 242;
                        } else {
                            marginLeft = 222;
                        }
                    } else if (this.screenHeight >= 667) {
                        marginLeft = 222;
                    } else {
                        marginLeft = 212;
                    }
                    break;
                }
                case 4: {
                    if (this.screenHeight >= 896) {
                        marginLeft = 270;
                    } else if (this.screenHeight >= 812) {
                        marginLeft = 250;
                    } else if (this.screenHeight >= 667) {
                        marginLeft = 252;
                    } else {
                        marginLeft = 242;
                    }
                    break;
                }
                default:
                    break;
            }
            return marginLeft;
        },
        guideMarginTop() {
            let marginTop = 0;
            if (this.screenHeight >= 812) {
                switch (this.guideType) {
                    case 0: {
                        if (this.screenHeight >= 896) {
                            marginTop = 162;
                        } else {
                            marginTop = 150;
                        }
                        break;
                    }
                    case 1: {
                        if (this.screenHeight >= 896) {
                            marginTop = 150;
                        } else {
                            marginTop = 140;
                        }
                        break;
                    }
                    case 2: {
                        if (this.screenHeight >= 896) {
                            marginTop = 218;
                        } else {
                            marginTop = 204;
                        }
                        break;
                    }
                    case 3: {
                        if (this.screenHeight >= 896) {
                            marginTop = 212;
                        } else {
                            marginTop = 190;
                        }
                        break;
                    }
                    case 4: {
                        if (this.screenHeight >= 896) {
                            marginTop = 148;
                        } else {
                            marginTop = 125;
                        }
                        break;
                    }
                    default:
                        break;
                }
            } else {
                switch (this.guideType) {
                    case 0: {
                        marginTop = 140;
                        break;
                    }
                    case 1: {
                        marginTop = 134;
                        break;
                    }
                    case 2: {
                        marginTop = 194;
                        break;
                    }
                    case 3: {
                        marginTop = 180;
                        break;
                    }
                    case 4: {
                        if (this.screenHeight >= 667) {
                            marginTop = 115;
                        } else {
                            marginTop = 105;
                        }
                        break;
                    }
                    default:
                        break;
                }
            }
            return marginTop;
        },
        guideClick() {
            if (this.guideType >= 0 && this.guideType < 12) {
                this.POINT('h5_clk', {
                    page: 'super-成长权益页',
                    tgt_event_id: 'h5_ACT_privilege_0djdjydmc',
                    tgt_name: 'h5-ACT-成长权益-0等级点击引导蒙层',
                    param: this.scoreInfoData.totalScore,
                    param1: this.scoreInfoData.allScore,
                    param2: this.guideType < 10 ? '气泡' : '任务按钮',
                    param3: '否'
                });
            } else if (this.guideType > 19) {
                this.POINT('h5_clk', {
                    page: 'super-成长权益页',
                    tgt_event_id: 'h5_ACT_privilege_fdqydjydmc',
                    tgt_name: 'h5-ACT-成长权益-浮动权益点击引导蒙层',
                    param: this.scoreInfoData.totalScore,
                    param1: this.scoreInfoData.allScore,
                    param2: this.bubbleData.desc,
                    param3: this.butnTitle(this.bubbleData),
                    param4:
                        this.bubbleData.benefitKey === 'fdqy' ? this.bubbleData.couponBatchNo : '',
                    param5: '否'
                });
            }
            this.$emit('OnGuideClick');
        },
        butnTitle(item) {
            let benSta = item.benefitStatus;
            return benSta === 10
                ? '立即领取'
                : benSta === 20
                    ? '已领取'
                    : benSta === 21
                        ? '去使用'
                        : benSta === 22
                            ? '已使用'
                            : benSta === 30
                                ? '已过期'
                                : '';
        },
        butnStyle(item) {
            if (
                item.benefitStatus === 20 ||
                item.benefitStatus === 22 ||
                item.benefitStatus === 30
            ) {
                return 'butn-with-gray';
            } else {
                return 'quan-butn';
            }
        }
    }
};
</script>
<style lang="less" scoped>
@asserts: '../../../../assets/iconV2.5/';
.contaier {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.6);
    z-index: 100;
    .guide {
        display: flex;
        flex-direction: column;
        align-items: center;
        .guide-bg {
            width: 36px;
            height: 36px;
            background-size: 100% 100%;
            font-size: 14px;
            font-weight: bold;
            text-align: center;
            line-height: 40px;
        }
        .coin-bg {
            color: #df5d1f;
            background-image: url('@{asserts}/coin-icon@2x.png');
        }
        .qipao-bg {
            color: #fff;
            background-image: url('@{asserts}/qipao-high@2x.png');
        }
        .guide-tit {
            margin-top: 6px;
            color: #905d3c;
            font-size: 10px;
            // font-family: fzlt_bold;
            font-weight: bold;
        }
        .guide-df {
            // position: absolute;
            margin-left: 36px;
            margin-top: -64px;
            width: 100px;
            height: 100px;
            background-image: url('@{asserts}/finger-df1.gif');
            background-size: 100% 100%;
        }
    }
    .butn-guide {
        margin-top: 390px;
        margin-left: 16px;
        .task-card {
            width: 185px;
            height: 76px;
            background: #fff;
            border-radius: 5px;
            border: 1px solid #ffffff;
            padding: 18px 12px 0;
            .card-tit {
                color: #863e1e;
                font-size: 14px;
                font-weight: bold;
            }
            .card-desc {
                margin-top: 8px;
                color: #863e1e;
                opacity: 0.65;
                font-size: 11px;
            }
        }
        .butn-guide-df {
            position: absolute;
            margin-left: 110px;
            margin-top: -56px;
            width: 100px;
            height: 100px;
            background-image: url('@{asserts}/finger-df3.gif');
            background-size: 100% 100%;
        }
    }
    .postion0 {
        margin-left: 16px;
    }
    .postion1 {
        margin-left: 102px;
    }
    .postion2 {
        margin-left: 188px;
    }
    .postion3 {
        margin-left: 274px;
    }
    .quan-bg {
        padding-top: 13px;
        margin-top: 464px;
        width: 86px;
        height: 110px;
        background-size: 100% 100%;
        text-align: center;
        background-image: url('@{asserts}/floatCoupon-card@2x.png');
        .quan-title {
            color: #fff;
            font-size: 12px;
            // font-family: fzlt_bold;
            font-weight: bold;
        }
        .quan-value {
            margin-top: 18px;
            color: #3f5862;
            font-size: 14px;
            // font-family: fzlt_bold;
            font-weight: bold;
        }
        .quan-desc {
            margin-top: 4px;
            color: #ff4d00;
            font-size: 8px;
            // font-family: fzlt;
        }
        .quan-butn {
            margin: 6px 12px 0;
            width: 60px;
            height: 20px;
            border-radius: 10px;
            font-size: 11px;
            // font-family: fzlt_bold;
            font-weight: bold;
            line-height: 20px;
            background-image: url('@{asserts}/benefit-butn.gif');
            background-size: 100% 100%;
            color: #fff;
        }
        .quan-df {
            position: relative;
            margin-top: -38px;
            margin-left: 30px;
            width: 100px;
            height: 100px;
            background-image: url('@{asserts}/finger-df2.gif');
            background-size: 100% 100%;
        }
        .butn-with-gray {
            margin: 6px 0 0;
            width: 100%;
            height: 20px;
            font-size: 11px;
            // font-family: fzlt_bold;
            font-weight: bold;
            color: #c8c8c8;
        }
    }
}
</style>